import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Stack,
  Skeleton,
  Box,
} from '@chakra-ui/react';
import QuestAdminItem from 'components/quest/QuestAdminItem';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { courseActions } from 'store/modules/course/course-slice';
import { fetchCourseQuestsAction } from 'store/modules/quest/quest-actions';
import { ReducerStatus } from 'utils/constants';

function CoursePreviewMd() {
  const dispatch = useDispatch();

  const coursePreview = useSelector((state) => state.course.coursePreview);
  const courseQuests = useSelector((state) => state.quest.courseQuests);
  const getQuestsStatus = useSelector((state) => state.quest.getQuestsStatus);

  useEffect(() => {
    if (coursePreview.modal && coursePreview.id) {
      dispatch(fetchCourseQuestsAction(coursePreview.id));
    }
  }, [coursePreview, dispatch]);
  const handleCloseModal = (isOpen) => {
    dispatch(
      courseActions.setCoursePreview({
        modal: isOpen,
      })
    );
  };

  return (
    <Modal
      size="2xl"
      isOpen={coursePreview.modal}
      onClose={() => handleCloseModal(false)}
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Course Preview</ModalHeader>
        <ModalCloseButton />
        <ModalBody minH={230}>
          {getQuestsStatus === ReducerStatus.LOADING ? (
            <Stack align="stretch">
              <Skeleton mb={6} height="72px" borderRadius="md" />
              <Skeleton mb={6} height="72px" borderRadius="md" />
              <Skeleton mb={6} height="72px" borderRadius="md" />
              <Skeleton mb={6} height="72px" borderRadius="md" />
            </Stack>
          ) : (
            <Box>
              {coursePreview.id && (
                <>
                  {courseQuests.map((courseQuest) => (
                    <QuestAdminItem
                      key={courseQuest.id}
                      courseId={coursePreview.id}
                      id={courseQuest.id}
                      courseQuest={courseQuest}
                      isPreviewMode
                    />
                  ))}
                </>
              )}
            </Box>
          )}
        </ModalBody>

        <ModalFooter>
          <Button
            colorScheme="blue"
            mr={3}
            onClick={() => handleCloseModal(false)}
          >
            Close
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}

export default CoursePreviewMd;
